import { PureComponent } from 'react';
import { downloadLog, netWorkerClear } from '../../actions';

import { List } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectDownloadingLogKeys,
  makeSelectMessagesNetWorker,
} from '../../selectors';
import Terminal from './Terminal';

class NetWorker extends PureComponent {
  static propTypes = {
    msg: PropTypes.object.isRequired,
    netWorker: PropTypes.instanceOf(List),
    onDownloadLog: PropTypes.func.isRequired,
    onNetWorkerClear: PropTypes.func.isRequired,
    downloadingLogKeys: ImmutablePropTypes.list.isRequired,
  };

  render() {
    const {
      msg,
      onNetWorkerClear,
      netWorker,
      onDownloadLog,
      downloadingLogKeys,
    } = this.props;
    return (
      <Terminal
        btnClearTitle={msg.btnClearTitle}
        defaultCountRows={20}
        divClass='col-xs-12'
        downloadLogKey='networker'
        heightPx={250}
        label={msg.netWorker}
        messagesList={netWorker}
        msg={msg}
        onClear={onNetWorkerClear}
        onDownloadLog={onDownloadLog}
        downloading={downloadingLogKeys.includes('networker')}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  netWorker: makeSelectMessagesNetWorker(),
  downloadingLogKeys: makeSelectDownloadingLogKeys(),
});

function mapDispatchToProps(dispatch) {
  return {
    onDownloadLog: (args) => dispatch(downloadLog(args)),
    onNetWorkerClear: () => dispatch(netWorkerClear()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NetWorker);
